import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, ShieldCheck } from "lucide-react";
import { Reveal } from "./Motion";
import { MANIFESTO, ASSETS, WHATSAPP_URL } from "../data/site";

export const About = () => (
  <section
    id="sobre"
    data-testid="about-section"
    className="relative bg-[#0a0a0a] py-20 md:py-28"
  >
    <div className="max-w-[1400px] mx-auto px-4 md:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      {/* Image with clipped frame + parallax feel */}
      <Reveal className="order-2 lg:order-1">
        <div className="relative">
          <div className="relative clip-frame-alt overflow-hidden border border-white/10">
            <motion.img
              src={ASSETS.truckSideLogo}
              alt="Caminhão-guincho FS Guinchos"
              className="w-full h-[380px] md:h-[520px] object-cover"
              initial={{ scale: 1.15 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/60 to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-2 md:right-6 bg-[#e60000] text-white px-6 py-4 red-glow">
            <span className="font-mono-tech text-xs tracking-widest block opacity-80">
              ATENDIMENTO
            </span>
            <span className="font-display font-bold text-3xl leading-none">24 HORAS</span>
          </div>
        </div>
      </Reveal>

      {/* Text */}
      <div className="order-1 lg:order-2">
        <Reveal>
          <span className="font-mono-tech text-xs tracking-[0.25em] text-[#e60000] uppercase">
            / Sobre a empresa
          </span>
          <h2 className="mt-4 font-display font-bold uppercase text-white text-4xl md:text-5xl tracking-tight leading-[0.95]">
            Sobre a FS Guinchos
          </h2>
          <p className="mt-5 text-neutral-400 leading-relaxed">
            A FS Guinchos oferece serviços de guincho, reboque e transporte de
            veículos em Porto Alegre e Região Metropolitana. Nosso objetivo é
            proporcionar atendimento rápido, seguro e eficiente para motoristas que
            precisam de suporte em situações emergenciais ou para o transporte de
            seus veículos.
          </p>
          <p className="mt-4 text-neutral-400 leading-relaxed">
            Com atendimento 24 horas, trabalhamos para oferecer praticidade e
            tranquilidade nos momentos em que você mais precisa. Também realizamos
            atendimentos para outras cidades e estados, mediante consulta.
          </p>
        </Reveal>

        <div className="mt-8 space-y-5">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.1}>
              <div className="flex gap-5 border-t border-white/10 pt-5">
                <span className="font-display font-bold text-[#e60000] text-2xl md:text-3xl leading-none w-10 shrink-0">
                  {m.n}
                </span>
                <div>
                  <h3 className="font-display font-semibold text-white text-lg">
                    {m.title}
                  </h3>
                  <p className="mt-1 text-neutral-400 text-sm leading-relaxed">
                    {m.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <a
            data-testid="about-whatsapp-btn"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1eb85a] text-black px-7 py-4 font-bold uppercase tracking-wide transition-colors wa-glow"
          >
            <MessageCircle size={20} />
            Falar com a FS Guinchos
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
